import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { PotentialCause } from '../models/potential-cause.model';
import { CreatePotentialCauseRequest } from '../models/requests/create-potential-cause-request';
import { UpdatePotentialCauseRequest } from '../models/requests/update-potential-cause-request';

@Injectable({
  providedIn: 'root',
})
export class PotentialCauseService {
  constructor(private apiService: ApiService) {}

  public GetByRuleUid(
    ruleUniqueId: string | undefined
  ): Observable<PotentialCause[]> {
    const options = {
      queryParams: {
        Uid: ruleUniqueId ? ruleUniqueId.toString() : '',
      },
    };
    return this.apiService.get<PotentialCause[]>(
      `/PotentialCause/GetByRuleUid`,
      options
    );
  }

  public DeleteMultiplePotentialCauses(uids: string[]): Observable<any> {
    return this.apiService.post(`/PotentialCause/DeleteMultiple`, uids);
  }

  public UpdateMultiplePotentialCauses(
    payload: UpdatePotentialCauseRequest[]
  ): Observable<PotentialCause[]> {
    return this.apiService.put<PotentialCause[]>(
      `/PotentialCause/UpdateMultiple`,
      payload
    );
  }

  public CreateMultiplePotentialCauses(
    payload: CreatePotentialCauseRequest[]
  ): Observable<PotentialCause[]> {
    return this.apiService.post<PotentialCause[]>(
      `/PotentialCause/CreateMultiple`,
      payload
    );
  }
}
